import { useMemo } from 'react';
import qs from 'qs';
import { useLocation } from 'react-router';

const useQuery = <Q extends Record<string, string | string[]>>(): Partial<Q> => {
  const location = useLocation();
  return useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }) as Q, [location.search]);
};

export default useQuery;
